import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { ValidationController } from 'aurelia-validation';
import { StandardValidationBuilder } from 'lib/validation';
import { Models } from 'models/core';
import { ErrorService } from 'services/error-service';
import { ProductService } from 'services/product-service';
import { ToastService } from 'services/toast-service';

@autoinject
export class ProductsNew {
  private product: Models.Product = new Models.Product();

  private constructor(
    private errorService: ErrorService,
    private eventAggregator: EventAggregator,
    private router: Router,
    private toastService: ToastService,
    private productService: ProductService,
    private ruleBuilder: StandardValidationBuilder,
    protected validationController: ValidationController
  ) {}

  private async activate() {
    this.createValidationRules();
  }

  protected async createProduct() {
    const { valid } = await this.validationController.validate();
    if (!valid) return;

    this.product.ExternalName = this.product.Name;
    this.product.ExternalName2 = this.product.Name;

    this.productService
      .post(this.product)
      .then(() => {
        this.eventAggregator.publish('productsListReset', 1);
        this.toastService.showSuccess('Created');
        this.router.navigateToRoute('products-list');
      })
      .catch((err) => this.errorService.handleError(err));
  }

  private createValidationRules() {
    this.ruleBuilder.with(this.product).required('ProductSource').required('Name').required('ArticleNo').done();
  }
}
